import React from 'react'
import './DocumentTrustComponent.css'

import checkIcon from '../../../assets/icons/check-mark.png'
import { formatLabel } from '../../../utils/stringUtils'

const DocumentTrustComponent = ({ title, items }) => {

    let trustItemsObj = null;

    const getLabelText = (key) => {
        // Special case for screenshot check
        if (key === 'notScreenshot') {
            return 'Not a Screenshot';
        }
        return formatLabel(key);
    };

    if (title === "Biometrics Trust") {
        trustItemsObj = {
            'PassiveLiveness': items?.passiveLivenessResult,
            ...(items?.activeLivenessResult != null && {
                'ActiveLiveness': items?.activeLivenessResult
            }
            ),
            'FaceMatch': items?.faceAuthResult,
        }
    } else {

        const processedItems = Object.entries(items).reduce((acc, [key, value]) => {
            if (key === 'isScreenshot') {
                // Invert the logic for screenshot and rename for clarity
                acc['notScreenshot'] = value === false;
            } else {
                // Handle other items normally
                acc[key] = value === true;
            }
            return acc;
        }, {});

        trustItemsObj = { ...processedItems };
    }

    return (
        <div className="document-trust-container review-component-container full-width">
            <div className="document-trust-header">
                <h2 className="document-trust-title">{title}</h2>
            </div>
            <div className="document-trust-grid">
                {Object.entries(trustItemsObj).map(([key, value]) => {
                    return (
                        <div key={key} className={`trust-item ${value ? 'verified-border' : 'pending-border'}`}>
                            <div className="trust-status">{getLabelText(key)}</div>
                            <div className={`trust-indicator ${value ? 'verified' : 'pending'}`}>
                                {value && (
                                    <span className="check-icon">
                                        <img src={checkIcon} alt="Checked" className="icon" />
                                    </span>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default DocumentTrustComponent